module.exports = __webpack_public_path__ + "img/arrow-right.fe120959.svg";